module.exports = __webpack_public_path__ + "img/team-marie-tasche@2x.9b034041.jpg";